import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-result-share-links',
  templateUrl: './result-share-links.component.html',
  styleUrls: ['./result-share-links.component.scss']
})
export class ResultShareLinksComponent implements OnInit {
  url = window.location.host;
  text = 'Neuroscientific test for anxiety and depression. Anima turns your gaze into actionable insights, guiding you toward the best coping strategies for a healthier mind.';

  constructor() { }

  ngOnInit(): void {
  }

}
